module.exports = __webpack_public_path__ + "img/back.a6403d52.png";